/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useState } from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { InlineNotification, Link, Typography2 } from '@coursera/cds-core';

import type { CourseDetails } from 'bundles/page-config-common/providers/enterprise/EnterpriseEnrolledCourseProvider';

import _t from 'i18n!nls/consumer-home';

type Props = {
  previouslyCompletedCourse: CourseDetails;
};

const styles = {
  notification: css`
    margin: var(--cds-spacing-150) 0;
    border: 1px solid var(--cds-color-green-700);
  `,
};

export const EnterpriseContinueLearningCourseCardNotification = ({ previouslyCompletedCourse }: Props) => {
  const [dismissNotification, setDismissNotification] = useState(false);

  if (dismissNotification) {
    return null;
  }

  return (
    <InlineNotification css={styles.notification} severity="success" onDismiss={() => setDismissNotification(true)}>
      <div>
        <Typography2 component="h3" variant="subtitleMedium">
          <FormattedMessage
            message={_t('Congratulations on completing {courseLink}')}
            courseLink={
              <Link
                href={`/learn/${previouslyCompletedCourse?.slug}/home/welcome`}
                variant="quiet"
                target="_blank"
                tabIndex={-1}
              >
                {previouslyCompletedCourse?.name}
              </Link>
            }
          />
        </Typography2>
        <Typography2 component="p" variant="bodyPrimary">
          <FormattedMessage message={_t('Keep going with the next course in this specialization.')} />
        </Typography2>
      </div>
    </InlineNotification>
  );
};

export default EnterpriseContinueLearningCourseCardNotification;
